import React, { useState } from 'react';
import { Box, Button, Flex } from '@chakra-ui/react';
import {
  belowButtonStyles,
  buttonVariantStyles,
  carouselButtonStyles,
  carouselFlexStyles,
  containerStyles,
  layerStyles,
  skewStyles,
} from './constant';
import { JumbotronPropTypes } from './JumbotronPropTypes';
import { JumboText } from './JumboText';
import { CTAButton } from './CTAButton';
export const Jumbotron = ({
  variant,
  title,
  paragraph,
  ctaButtonConfig,
  images,
  layer,
  buttonBelow,
}: JumbotronPropTypes.IJumbotronProps) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  if (variant !== 'button') {
    buttonBelow = false;
  }

  const DefaultVariant = () => {
    return (
      <JumboText
        variant={variant}
        title={title}
        paragraph={paragraph}
        ctaButtonConfig={ctaButtonConfig}
      />
    );
  };
  const ModalVariant = () => {
    return (
      <JumboText
        variant={variant}
        title={title}
        paragraph={paragraph}
        ctaButtonConfig={ctaButtonConfig}
      />
    );
  };
  const ButtonVariant = () => {
    return (
      ctaButtonConfig && (
        <Flex
          {...buttonVariantStyles}
          display={buttonBelow ? 'none' : 'flex'}
          justifyContent={{ base: 'end', sm: 'center' }}
          direction={{ base: 'column', sm: 'row' }}
          alignItems={{ base: 'center', sm: 'end' }}
        >
          <CTAButton
            ctaButtonConfig={ctaButtonConfig}
            breakpoints={{ base: '200px', sm: '145px' }}
          />
        </Flex>
      )
    );
  };

  return (
    <Flex
      display='flex'
      alignItems='center'
      justifyContent='center'
      height={{ base: '32vh', sm: '78.5vh', md: '62vh' }}
    >
      <Box
        bg={`url(${images[selectedIndex].url})`}
        bgSize="cover"
        bgPosition="center"
        bgRepeat="no-repeat"
        width="100%"
        height="100%"
      >
        <Flex direction={'column'} position='relative' height='100%'>
          <Flex
            {...containerStyles}
            direction={buttonBelow ? 'row' : 'column'}
            height={{
              base: variant === 'default' || variant === 'modal' ? '100%' : '446px',
              sm: variant === 'default' || variant === 'modal' ? '100%' : '760px',
              md: variant === 'default' || variant === 'modal' ? '100%' : '560px',
            }}
            justifyContent={variant === 'button' || variant === 'image' ? 'center' : 'space-around'}
            maxHeight={{ base: buttonBelow ? '200px' : 'auto', sm: buttonBelow ? '440px' : 'auto' }}
          >

            <Box
              {...layerStyles}
              backgroundColor={{
                base: variant === 'default' ? 'background.shadow' : 'transparent',
                sm: layer && variant !== 'image' ? 'background.shadow' : 'transparent',
              }}
              display={{ base: 'none', sm: 'unset' }}
            ></Box>
            {variant === 'default' && (
              <Box
                {...skewStyles}
                display={{ base: 'none', sm: 'block' }}
                width={{ base: 'none', sm: '130%', md: '100%' }}
              ></Box>
            )}

            {
              {
                button: <ButtonVariant />,
                modal: <ModalVariant />,
                default: <DefaultVariant />,
                image: null,
              }[variant]
            }

            {images?.length - 1 > 0 && (
              <Flex
                {...carouselFlexStyles}
                zIndex={buttonBelow ? 1 : 0}
                top={buttonBelow ? { base: '180px', sm: '400px' } : ''}
                bottom={buttonBelow ? '' : 5}
              >
                {images.map((_, index) => {
                  return (
                    <Button
                      {...carouselButtonStyles}
                      backgroundColor={selectedIndex === index ? 'button.blue' : ''}
                      onClick={() => setSelectedIndex(index)}
                    ></Button>
                  );
                })}
              </Flex>
            )}
          </Flex>
          {buttonBelow && ctaButtonConfig && (
            <Flex
              {...belowButtonStyles}
              display={{ base: 'flex', md: 'none' }}
              direction={{ base: 'column', sm: 'row' }}
            >
              <CTAButton
                ctaButtonConfig={ctaButtonConfig}
                breakpoints={{ base: '200px', md: '335px' }}
              />
            </Flex>
          )}
        </Flex>
      </Box>
    </Flex>
  );
};
